import React, { useState, useEffect, useCallback } from 'react';
import getList from '../../api/Admin/getList';
import putUserAPI from '../../api/Admin/putUser';
import deleteUserAPI from '../../api/Admin/deleteUser';
import styles from './AdminPanel.module.css';

const AdminList = () => {
    const [filters, setFilters] = useState({
        id: '', email: '', role: '', banned: '', validTrader: ''
    });
    const [listUser, setListUser] = useState([]);

  const Search = useCallback(async () => {
    const params = {
      id: filters.id || undefined,
      email: filters.email || undefined,
      role: filters.role || undefined,
      banned: filters.banned === '1' ? true : filters.banned === '0' ? false : undefined,
      validTrader: filters.validTrader === '1' ? true : filters.validTrader === '0' ? false : undefined,
    };

    const result = await getList(params);
    setListUser(result.ok ? result.data : []);
    if (!result.ok) console.error("Erreur lors du chargement :", result.status);
  }, [filters]); // ← include filters if Search uses it

  useEffect(() => {
    Search();
  }, [Search]);

    const handleFilterChange = (e) =>
        setFilters({ ...filters, [e.target.name]: e.target.value });

    const handleUserChange = (id, field, value) => {
        setListUser(prev =>
            prev.map(user =>
                user.id === id ? { ...user, [field]: value } : user
            )
        );
    };

    const handlePutUser = async (user) => {
        const result = await putUserAPI(user);
        if (result.ok) {
            alert(`✅ Utilisateur ${user.email} mis à jour`);
            Search();
        } else {
            alert(`❌ Erreur (${result.status}) : ${result.data?.msg || result.error}`);
        }
    };

    const handleDeleteUser = async (user) => {
        if (!window.confirm(`Supprimer l'utilisateur ${user.email} ?`)) return;
        const result = await deleteUserAPI(user.id);
        if (result.ok) {
            alert(`🗑️ Utilisateur ${user.email} supprimé`);
            setListUser(prev => prev.filter(u => u.id !== user.id));
        } else {
            alert(`❌ Erreur (${result.status}) : ${result.data?.msg || result.error}`);
        }
    };

    // 🎨 Affichage du tableau
    return (
        <table className={styles.table}>
            <thead>
                <tr>
                    {['ID', 'Email', 'Rôle', 'Banni', 'Commerçant', 'Action'].map((h, i) => (
                        <th key={i}>{h}</th>
                    ))}
                </tr>
                <tr>
                    <th><input name="id" type="number" placeholder="ID utilisateur"
                        onChange={handleFilterChange} className={styles.field} /></th>
                    <th><input name="email" type="email" placeholder="Email utilisateur"
                        onChange={handleFilterChange} className={styles.field} /></th>
                    <th>
                        <select name="role" onChange={handleFilterChange}>
                            <option value="">Tous</option>
                            <option value="trader">Commerçant</option>
                            <option value="client">Client</option>
                            <option value="admin">Admin</option>
                        </select>
                    </th>
                    <th>
                        <select name="banned" onChange={handleFilterChange}>
                            <option value="">Tous</option>
                            <option value="1">Bannis</option>
                            <option value="0">Non bannis</option>
                        </select>
                    </th>
                    <th>
                        <select name="validTrader" onChange={handleFilterChange}>
                            <option value="">Tous</option>
                            <option value="0">En attente</option>
                            <option value="1">Autorisé</option>
                        </select>
                    </th>
                    <th><button onClick={Search}>Rechercher</button></th>
                </tr>
            </thead>

            <tbody>
                {listUser.length > 0 ? (
                    listUser.map((user) => (
                        <tr key={user.id}>
                            <td><input readOnly className={styles.field} value={user.id} /></td>
                            <td><input readOnly className={styles.field} value={user.email} /></td>
                            <td>
                                <select
                                    value={user.role}
                                    onChange={(e) => handleUserChange(user.id, 'role', e.target.value)}
                                >
                                    <option value="trader">Commerçant</option>
                                    <option value="client">Client</option>
                                    <option value="admin">Admin</option>
                                </select>
                            </td>
                            <td>
                                <select
                                    value={user.banned ? '1' : '0'}
                                    onChange={(e) =>
                                        handleUserChange(user.id, 'banned', e.target.value === '1')
                                    }
                                >
                                    <option value="1">Banni</option>
                                    <option value="0">Non banni</option>
                                </select>
                            </td>
                            <td>
                                <select
                                    value={user.validTrader ? '1' : '0'}
                                    onChange={(e) =>
                                        handleUserChange(user.id, 'validTrader', e.target.value === '1')
                                    }
                                >
                                    <option value="0">En attente</option>
                                    <option value="1">Autorisé</option>
                                </select>
                            </td>
                            <td>
                                <button onClick={() => handlePutUser(user)}>Mettre à jour</button>
                                <button onClick={() => handleDeleteUser(user)}>Supprimer</button>
                            </td>
                        </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan="6" style={{ textAlign: 'center', padding: '10px' }}>
                            Aucun utilisateur trouvé
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
    );
};

export default AdminList;
